<template>
  <v-dialog v-model="overrideDialog" max-width="1000px" scrollable>
    <v-card class="elevation-1 override-rule vop-bg-whisper">
      <v-layout column justify-space-between>
        <v-layout column>
          <!-- Toolbar -->
          <v-toolbar flat class="vop-bg-whisper">
            <!-- Title -->
            <v-toolbar-title class="subheading ttu font-weight-medium">
              <span v-if="ruleType === 'rule'"> {{ messages.label.OVERRIDE_RULE }}</span>
              <span v-if="ruleType === 'ruleSet'"> {{ messages.label.OVERRIDE_RULE_SET }}</span>
              <span v-if="ruleType === 'ruleCollection'"> {{ messages.label.OVERRIDE_RULE_COLLECTION }}</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <!-- Close button -->
            <v-toolbar-items>
              <v-btn icon medium @click="hide()">
                <v-icon>mdi-window-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <!-- Main Content -->
          <v-card-text class="pa-2">
            <v-layout row wrap>
              <!-- Error Alert -->
              <v-flex xs12 v-if="errorAlert">
                <v-alert v-model="errorAlert" dismissible type="error" class="mt-0">
                  {{ errorMessage }}
                </v-alert>
              </v-flex>
              <!-- Original Rule Info -->
              <v-flex xs5>
                <h2 class="body-2 ttu caption pa-2 ml-2 font-weight-bold">{{ messages.label.ORIGINAL }}</h2>
                <v-data-table :items="ruleDetails" hide-actions hide-headers class="pa-2">
                  <template slot="items" slot-scope="props">
                    <tr>
                      <td class="text-xs-left ttu">{{ props.item.name | ownerLabel }}</td>
                      <td class="text-xs-left">
                        <!-- Owner -->
                        <template v-if="props.item.name === 'ownerId'">
                          {{ getOwnerName(props.item.value) }}
                        </template>
                        <!-- Provider -->
                        <template v-else-if="props.item.name === 'secondaryOwner'">
                          {{ getProviderName(props.item.value) }}
                        </template>
                        <template v-else>
                          <div>
                            {{ props.item.value | displayNA }}
                          </div>
                        </template>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
              <!-- Copy Rule Info -->
              <v-flex xs6 offset-xs1>
                <h2 class="body-2 ttu caption pa-2 font-weight-bold">{{ messages.label.NEW }}</h2>
                <v-form class="px-2">
                  <!-- Rule Title -->
                  <v-flex xs10>
                    <v-text-field v-model="overrideRuleData.title" clearable v-validate="'required|max:100'"
                      :error-messages="errors.collect('title')" data-vv-name="title" :counter="100"
                      :label="messages.label.RULE_TITLE" required>
                    </v-text-field>
                  </v-flex>
                  <!-- Rule Description -->
                  <v-flex xs10>
                    <v-textarea v-model="overrideRuleData.description" clearable v-validate="'max:100'"
                      :error-messages="errors.collect('description')" data-vv-name="description" :counter="500"
                      :label="messages.label.RULE_DESCRIPTION" required>
                    </v-textarea>
                  </v-flex>
                  <!-- Provider Group -->
                  <!-- <div v-if="IS_POLARIS"> -->
                  <!-- <v-flex sm6>
                      <v-autocomplete v-model="selectedProviderGroup" :label="messages.label.PROVIDER_GROUP"
                        item-text="title" item-value="title" :loading="loadingProviderGroups" :items="providerGroups"
                        return-object :disabled="isProviderGroupDisabled"
                        @change="retrieveSecondaryOwners(selectedProviderGroup)">
                        <template v-slot:no-data>
                          <v-list-tile>
                            <v-list-tile-title>
                              No Provider groups
                            </v-list-tile-title>
                          </v-list-tile>
                        </template>
                      </v-autocomplete>
                    </v-flex> -->
                  <!-- Provider -->
                  <!-- <v-flex xs6>
                      <v-autocomplete v-model="selectedSecondaryOwner" :label="messages.label.PROVIDER_NAME"
                        :loading="loadingSecondaryOwner" item-text="title" item-value="title" return-object
                        :items="secondaryOwners">
                      </v-autocomplete>
                    </v-flex> -->
                  <!-- </div> -->
                  <!-- <div v-else> -->
                  <div>
                    <!-- Sub Account -->
                    <!-- <v-flex sm6 v-if="mpxSubAccounts.length > 0">
                      <v-autocomplete v-model="selectedSubAccount" :label="messages.label.SUB_ACCOUNT" item-text="title"
                        item-value="title" :loading="loadingSubAccounts" :items="mpxSubAccounts" return-object>
                      </v-autocomplete>
                    </v-flex> -->
                    <!-- Sub Account Title-->
                    <!-- <v-flex sm6 v-else>
                      <v-text-field v-model="providerName" v-validate="'required|max:100'" data-vv-name="providerName"
                        :error-messages="errors.collect('providerName')" :counter="100"
                        :label="messages.label.SUB_ACCOUNT" required>
                      </v-text-field>
                    </v-flex> -->
                  </div>
                </v-form>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-layout>
        <v-card-actions class="px-3">
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-1 white--text" @click="hide()">
            {{ messages.label.CANCEL }}
          </v-btn>
          <v-btn color="primary" :disabled="overridingRule" :loading="overridingRule" @click="override()">
            {{ messages.label.OVERRIDE }}
          </v-btn>
        </v-card-actions>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex"
import { GET_PROVIDER_GROUPS, GET_MPX_SUB_ACCOUNTS } from "@/store/constants/action-types"
// import {
//   IS_POLARIS,
//   RULE_MGMT_DATA_SERVICE_URL,
//   VOD_SYCN_PREINGEST_DATA_SERVICE_URL
// } from "@/store/constants/getter-types"
// import { SECONDARY_OWNER_ANY } from "@/Shared/constants"
import * as xvatDataService from "@/XVAT/XVATDataService"
import XVATRulesService from "@/XVAT/XVATRulesService"
import AppService from "@/AppService"
import * as utils from "@/Shared/utils"
import messages from "@/XVAT/messages.json"

/**
 * initialData
 */
function initialData(instance) {
  return {
    ruleType: "rule",
    overridingRule: false,
    errorAlert: false,
    errorMessage: "",
    ruleDetails: [],
    overrideRuleData: {},
    loadingProviderGroups: false,
    selectedProviderGroup: {},
    loadingSecondaryOwner: false,
    selectedSubAccount: {},
    providerName: "",
    loadingSubAccounts: false,
    secondaryOwners: [],
    selectedSecondaryOwner: {}, // providers are secondary owners
    isProviderGroupDisabled: false,
    dictionary: instance.getValidationDictionary()
  }
}
export default {
  name: "XVATRuleOverride",
  $_veeValidate: {
    validator: "new"
  },
  props: {
    value: Boolean,
    ruleObj: Object
  },
  data: function () {
    return initialData(this)
  },
  watch: {
    overrideDialog(newValue) {
      if (newValue === true) {
        this.show()
      }
    }
  },
  computed: {
    ...mapState([
      "mpxParentAccount", "providerGroups", "mpxSubAccounts"
    ]),
    // ...mapGetters([
    //   RULE_MGMT_DATA_SERVICE_URL, IS_POLARIS, VOD_SYCN_PREINGEST_DATA_SERVICE_URL
    // ]),
    overrideDialog: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      }
    }
  },
  methods: {
    ...mapActions([
      GET_PROVIDER_GROUPS, GET_MPX_SUB_ACCOUNTS
    ]),

    /**
     * reset
     */
    reset() {
      Object.assign(this.$data, initialData(this))
    },

    /**
     * getValidationDictionary - Validation messages for vee-validate
     * @returns {object}
     */
    getValidationDictionary() {
      return {
        custom: {
          title: {
            required: () => "Title can't be empty",
            max: "Title may not be greater than 100 characters"
          },
          description: {
            max: "Description may not be greater than 500 characters"
          },
          providerName: {
            required: () => "Provider Name can't be empty",
            max: "Provider Name may not be greater than 100 characters"
          }
        }
      }
    },

    /**
     * hide - hide override modal
     */
    hide() {
      this.resetOverrideData()
      this.overrideDialog = false
    },

    /**
     * show - Show Override Rule / Rule Set / Rule Collection Modal
     */
    show() {
      this.resetOverrideData()
      this.initializeValue()
      this.parseRuleType()
      this.constructRuleDetails()
      // if (this.IS_POLARIS) {
      //   this.retrieveProviderGroups()
      // } else {
      //   this.retrieveSubAccounts()
      // }
    },

    /**
     * Re-initialize
     */
    resetOverrideData() {
      this.$validator.reset()
      this.ruleType = "rule"
      this.overridingRule = false
      this.errorAlert = false
      this.errorMessage = ""
      this.overrideRuleData = {}
    },

    /**
     * initialize value for overrideRuleData
     */
    initializeValue() {
      this.overrideRuleData = this.$lodash.cloneDeep(this.ruleObj)
      this.overrideRuleData.title = "OVERRIDE - " + this.ruleObj.title
      this.overrideRuleData.description = "OVERRIDE - " + this.ruleObj.description
    },

    /**
     * retrieveProviderGroups - retrieve provider groups
     */
    retrieveProviderGroups() {
      this.loadingProviderGroups = true
      this.GET_PROVIDER_GROUPS()
        .then(() => {
          let currentOwnerId = this.ruleObj.ownerId
          this.selectedProviderGroup = this.$lodash.find(this.providerGroups, { "ownerId": currentOwnerId })
          if (!this.$lodash.isUndefined(this.selectedProviderGroup)) {
            this.isProviderGroupDisabled = true
          } else {
            this.selectedProviderGroup = this.providerGroups[0]
            this.isProviderGroupDisabled = false
          }
          return this.retrieveSecondaryOwners(this.selectedProviderGroup)
        })
        .catch(() => {
          // TODO: handle error
        }).finally(() => {
          this.loadingProviderGroups = false
        })
    },

    /**
     * retrieveSubAccounts - retrieve provider groups
     */
    retrieveSubAccounts() {
      this.loadingSubAccounts = true
      this.GET_MPX_SUB_ACCOUNTS()
        .then(() => {
          let currentOwnerId = this.ruleObj.ownerId
          this.selectedSubAccount = this.$lodash.find(this.mpxSubAccounts, { "id": currentOwnerId })
          if (!this.$lodash.isUndefined(this.selectedSubAccount)) {
            this.isSubAccountDisabled = true
          } else {
            this.selectedSubAccount = this.mpxSubAccounts[0]
            this.isSubAccountDisabled = false
          }
        })
        .catch(() => {
          // TODO: handle error
        }).finally(() => {
          this.loadingSubAccounts = false
        })
    },

    /**
     * retrieveSecondaryOwners - Retrieve all providers from API service
     * @param {string} selectedSecondaryOwners
     */
    retrieveSecondaryOwners(providerGroup) {
      let queryObject = {}
      if (providerGroup.title === "Any") {
        return new Promise((resolve) => {
          this.secondaryOwners = []
          this.secondaryOwners.push({ title: "Any" })
          this.selectedSecondaryOwner = this.secondaryOwners[0]
          resolve()
        })
      } else {
        this.loadingSecondaryOwner = true
        queryObject["byProviderGroupId"] = providerGroup.id
        return xvatDataService
          .retrieveSecondaryOwners(queryObject, this.VOD_SYCN_PREINGEST_DATA_SERVICE_URL)
          .then((secondaryOwners) => {
            this.secondaryOwners = secondaryOwners
            this.selectedSecondaryOwner = this.secondaryOwners[0]
          })
          .catch(() => {
            // TODO: handle error
          }).finally(() => {
            this.loadingSecondaryOwner = false
          })
      }
    },

    /**
     * parseRuleType
     */
    parseRuleType() {
      if (!this.$lodash.isUndefined(this.ruleObj)) {
        let isRuleCollection = this.ruleObj.id.indexOf("/RuleCollection/") > 0
        let isRuleSet = this.ruleObj.id.indexOf("/RuleSet/") > 0
        let isRule = this.ruleObj.id.indexOf("/Rule/") > 0
        if (isRuleCollection) {
          this.ruleType = "ruleCollection"
        } else if (isRuleSet) {
          this.ruleType = "ruleSet"
        } else if (isRule) {
          this.ruleType = "rule"
        }
      }
    },

    /**
     * constructRuleDetails - Construct selected rule details
     * This is being done to display in a data table
     */
    constructRuleDetails() {
      this.ruleDetails = []
      // Convert object in to array of objects with key value pairs with required fields
      let requiredFields = ["title", "description", "ownerId", "providerGroup", "secondaryOwner"]
      requiredFields.forEach((fieldName) => {
        let obj = {}
        if (this.ruleObj.hasOwnProperty(fieldName)) {
          obj["name"] = fieldName
          obj["value"] = this.ruleObj[fieldName]
          this.ruleDetails.push(obj)
        }
        // } else if (fieldName === "providerGroup") {
        //   if (this.IS_POLARIS) {
        //     obj["name"] = fieldName
        //   } else {
        //     obj["name"] = "Sub Account"
        //   }
        //   obj["value"] = this.getProviderGroupName(this.ruleObj.ownerId)
        //   this.ruleDetails.push(obj)
        // }
      })
    },

    /**
     * getOwnerName
     */
    // getOwnerName(ownerId) {
    //   if (this.IS_POLARIS) {
    //     return XVATRulesService.getOwnerName(ownerId, this.mpxParentAccount.id, this.providerGroups, true)
    //   } else {
    //     return XVATRulesService.getOwnerName(ownerId, this.mpxParentAccount.id, this.mpxSubAccounts, false)
    //   }
    // },

    /**
     * getProviderGroupName
     * @param {stirng} ownerId
     */
    // getProviderGroupName(ownerId) {
    //   if (this.IS_POLARIS) {
    //     return XVATRulesService.getProviderGroupName(ownerId, this.mpxParentAccount.id, this.providerGroups, true)
    //   } else {
    //     return XVATRulesService.getProviderGroupName(ownerId, this.mpxParentAccount.id, this.mpxSubAccounts, false)
    //   }
    // },

    /**
     * getProviderName
     * @param {stirng} secondaryOwner
     */
    getProviderName(secondaryOwner) {
      return XVATRulesService.getProviderName(secondaryOwner)
    },

    /**
     * override - override rule / rule set / rule collection
     */
    override() {
      this.$validator.validateAll()
        .then((result) => {
          if (result) {
            this.overridingRule = true
            let ownerId = ""
            // if (this.IS_POLARIS) {
            //   ownerId = this.selectedProviderGroup.ownerId
            //   if (this.selectedSecondaryOwner.title === "Any") {
            //     this.overrideRuleData.secondaryOwner = SECONDARY_OWNER_ANY
            //   } else {
            //     this.overrideRuleData.secondaryOwner = this.selectedSecondaryOwner.title
            //   }
            // } else {
            //   if (this.$lodash.isEmpty(this.selectedSubAccount)) {
            //     ownerId = this.mpxParentAccount.id
            //   } else {
            //     ownerId = this.selectedSubAccount.id
            //   }
            //   if (this.$lodash.isEmpty(this.providerName.trim())) {
            //     this.overrideRuleData.secondaryOwner = SECONDARY_OWNER_ANY
            //   } else {
            //     this.overrideRuleData.secondaryOwner = this.providerName
            //   }
            // }
            let omitProperties = ["id", "updated", "added", "ownerId", "addedByUserId", "updatedByUserId", "version", "_added", "_enabled", "_updated"]
            this.overrideRuleData = this.$lodash.omit(this.overrideRuleData, omitProperties)
            let overrideRulePromise = {}
            switch (this.ruleType) {
              case "rule":
                overrideRulePromise = xvatDataService.createRule(this.overrideRuleData, ownerId, this.RULE_MGMT_DATA_SERVICE_URL)
                break
              case "ruleSet":
                overrideRulePromise = xvatDataService.createRuleSet(this.overrideRuleData, ownerId, this.RULE_MGMT_DATA_SERVICE_URL)
                break
              case "ruleCollection":
                overrideRulePromise = xvatDataService.createRuleCollection(this.overrideRuleData, ownerId, this.RULE_MGMT_DATA_SERVICE_URL)
                break
            }
            overrideRulePromise.then(() => {
              XVATRulesService.$emit("event:showOverrideRuleSuccessSnackBar", this.ruleType)
              this.hide()
            }).catch((error) => {
              this.showError(error)
            }).finally(() => {
              this.overridingRule = false
            })
          }
        })
    },

    /**
     * showError - Handles displaying error
     * @param {object} error
     */
    showError(error) {
      let isServerError = utils.isMPXError(error)
      let isClientError = utils.isClientError(error)
      if (isServerError) {
        this.errorAlert = true
        this.errorMessage = error.response.data.description
      } else if (isClientError) {
        this.errorAlert = true
        this.errorMessage = error.message
      }
    }
  },
  filters: {
    ownerLabel(value) {
      return XVATRulesService.getOwnerLabel(value)
    },
    displayNA(value) {
      if (value === null || value === "") {
        return "N/A"
      } else {
        return value
      }
    }
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages
    /**
    * Events
    */
    AppService.$on("event:mpxAccountChanged", this.reset)
  },
  beforeDestroy() {
    AppService.$off("event:mpxAccountChanged", this.reset)
  }
}
</script>

<style lang="scss">
.override-rule {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/XVAT/XVATRuleOverride.vue